export interface JobTitle {
  id: number;
  title_name_hu: string;
  title_name_en: string;
  role_key: string;
  is_active: boolean;
}

export interface Permission {
  page: string;
  action: string;
  description: string;
}

export interface RolePermissions {
  role: string;
  permissions: string[];
}

// Definiálódó oldalak és műveletek
export const PAGES = {
  OVERVIEW: 'overview',
  CALL_CENTER_DATABASE: 'call-center-database',
  CONTRACTS: 'contracts',
  CUSTOMERS: 'customers',
  ILLUSTRATIONS: 'illustrations',
  SUMMARY: 'summary',
  CALL_CENTER_STATS: 'call-center-stats',
  DAILY_REPORT: 'daily-report',
  ADMIN: 'admin',
  PROFILE: 'profile',
  CUSTOMER_DETAILS: 'customer-details',
  COMPANY_DETAILS: 'company-details',
  CALENDAR: 'calendar'
} as const;

export const ACTIONS = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  EXPORT: 'export',
  IMPORT: 'import'
} as const;

// Role-alapú jogosultságok konfigurációja (role_key alapján)
export const ROLE_PERMISSIONS: Record<string, string[]> = {
  // Adminisztrátor - minden oldalhoz hozzáférés
  'admin': [
    PAGES.OVERVIEW,
    PAGES.CALL_CENTER_DATABASE,
    PAGES.CONTRACTS,
    PAGES.CUSTOMERS,
    PAGES.ILLUSTRATIONS,
    PAGES.SUMMARY,
    PAGES.CALL_CENTER_STATS,
    PAGES.DAILY_REPORT,
    PAGES.ADMIN,
    PAGES.PROFILE,
    PAGES.CUSTOMER_DETAILS,
    PAGES.COMPANY_DETAILS,
    PAGES.CALENDAR
  ],

  // Call Center munkatárs - alapvető munkavégzéshez szükséges oldalak
  'call_center': [
    PAGES.OVERVIEW,
    PAGES.CALL_CENTER_DATABASE,
    PAGES.SUMMARY,           // ✅ Heti jelentés oldal
    PAGES.CALL_CENTER_STATS, // ✅ Teljesítménymutatók oldal
    PAGES.DAILY_REPORT,      // ✅ Napi riport oldal
    PAGES.PROFILE,
    PAGES.CALENDAR
  ],

  // Kiemelt Ügyfélmenedzser (KAM/KÜM) - ügyfélkezelés
  'kam': [
    PAGES.OVERVIEW,
    PAGES.SUMMARY,
    PAGES.PROFILE,
    PAGES.CUSTOMER_DETAILS,
    PAGES.COMPANY_DETAILS,
    PAGES.CALENDAR
  ],

  // Értékesítés támogatási vezető - értékesítési támogatás
  'sales_manager': [
    PAGES.OVERVIEW,
    PAGES.CALL_CENTER_DATABASE,
    PAGES.CONTRACTS,
    PAGES.CUSTOMERS,
    PAGES.ILLUSTRATIONS,
    PAGES.SUMMARY,
    PAGES.CALL_CENTER_STATS,
    PAGES.DAILY_REPORT,
    PAGES.PROFILE,
    PAGES.CUSTOMER_DETAILS,
    PAGES.COMPANY_DETAILS,
    PAGES.CALENDAR
  ],

  // Vezérigazgató-helyettes - ugyanazok a jogosultságok mint az Értékesítés támogatási vezetőnek
  'deputy-CEO': [
    PAGES.OVERVIEW,
    PAGES.CALL_CENTER_DATABASE,
    PAGES.CONTRACTS,
    PAGES.CUSTOMERS,
    PAGES.ILLUSTRATIONS,
    PAGES.SUMMARY,
    PAGES.CALL_CENTER_STATS,
    PAGES.DAILY_REPORT,
    PAGES.PROFILE,
    PAGES.CUSTOMER_DETAILS,
    PAGES.COMPANY_DETAILS,
    PAGES.CALENDAR
  ],

  // Befektetési divízió - befektetési termékek kezelése
  'investment': [
    PAGES.OVERVIEW,
    PAGES.CONTRACTS,
    PAGES.CUSTOMERS,
    PAGES.ILLUSTRATIONS,
    PAGES.PROFILE,
    PAGES.CUSTOMER_DETAILS,
    PAGES.COMPANY_DETAILS,
    PAGES.CALENDAR
  ],

  // Alapértelmezett jogosultságok ismeretlen szerepkörök esetén
  'default': [
    PAGES.OVERVIEW,
    PAGES.PROFILE,
    PAGES.CALENDAR
  ]
};

// Navigációs elemek konfigurációja
export interface NavigationItem {
  path: string;
  label: string;
  icon: string;
  requiredPermission: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    path: '/overview',
    label: 'Áttekintés',
    icon: 'dashboard',
    requiredPermission: PAGES.OVERVIEW
  },
  {
    path: '/call-center-database',
    label: 'Adatbázisom',
    icon: 'storage',
    requiredPermission: PAGES.CALL_CENTER_DATABASE
  },
  {
    path: '/calendar',
    label: 'Naptár',
    icon: 'calendar_month',
    requiredPermission: PAGES.CALENDAR
  },
  {
    path: '/contracts',
    label: 'Állománylista',
    icon: 'people',
    requiredPermission: PAGES.CONTRACTS
  },
  {
    path: '/customers',
    label: 'Ügyfelek',
    icon: 'person_search',
    requiredPermission: PAGES.CUSTOMERS
  },
  {
    path: '/illustrations',
    label: 'Ajánlatillusztrációk',
    icon: 'description',
    requiredPermission: PAGES.ILLUSTRATIONS
  },
  {
    path: '/summary',
    label: 'Teljesítmény összesítő',
    icon: 'analytics',
    requiredPermission: PAGES.SUMMARY
  },
  {
    path: '/call-center-stats',
    label: 'Heti jelentés',
    icon: 'assessment',
    requiredPermission: PAGES.CALL_CENTER_STATS
  },
  {
    path: '/daily-report',
    label: 'Napi riport',
    icon: 'today',
    requiredPermission: PAGES.DAILY_REPORT
  },
  {
    path: '/admin',
    label: 'Admin Panel',
    icon: 'admin_panel_settings',
    requiredPermission: PAGES.ADMIN
  }
];